import useToastContext from "hooks/useToastContext";
import { AiFillEdit } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import apiPath from "../../utils/pathObj";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";

const DepartmentList = ({ departmentList, page, allDepartment, handleEdit, sort, setSort }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.departmentStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allDepartment();
      }
    } catch (error) {
      console.log("error in get all country list==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Sr no.
                </th>
                <th className="px-6 py-3" scope="col">
                  {t("DEPARTMENT")}
                </th>
                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "createdAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "createdAt" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
                    </span>
                  </div>
                </th>
                <th
                  className="px-6 cursor-pointer py-3 "
                  scope="col"
                  onClick={() => {
                    if (sort.sortType === "asc" && sort.sortBy === "updatedAt") {
                      setSort({
                        sortBy: "updatedAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "updatedAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("UPDATED_DATE")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "updatedAt" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "updatedAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                    </span>
                  </div>
                </th>
                <th scope="col" className="px-6 text-center py-3 ">
                  {t("O_STATUS")}
                </th>
                <th className="py-3 px-6 text-center" scope="col">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {departmentList &&
                departmentList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="border-r py-4 px-6 text-gray-900">{item?.name}</td>
                      <td className="px-6 border-r text-gray-900 py-4 text-left">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-left y-4 px-6 border-r text-gray-900 ">{dayjs(item?.updatedAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-gray-900 border-r py-4 px-6 text-center">
                        <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="inline-flex items-center relative cursor-pointer">
                          <input
                            onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            type="checkbox"
                            checked={item?.status === "active"}
                            className="sr-only peer"
                          />
                          <div className="rounded-full peer peer-focus:ring-0 w-10 h-5 bg-gray-200 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      <td className="py-4 text-gray-900 px-6 border-l ">
                        <div className="">
                          <ul className="flex justify-center">
                            <li className="hover:bg-white px-2 py-2 hover:text-LightBlue" onClick={() => handleEdit(item)}>
                              <a title="Edit" data-bs-toggle="tooltip" className="transition hover:text-blue-700 duration-150 ease-in-out">
                                {" "}
                                <AiFillEdit className="text-slate-600 cursor-pointer w-5 h-5 " />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(departmentList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={6}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DepartmentList;
